<div [formGroup]="formGroup" class="flex flex-1 flex-col">
  <label for="scheduledDays" class="text-paragraph-xs-med text-greyscale-700">
    {{ "scheduledDaysSelector.scheduledOnDays" | transloco }}
  </label>
  <p-multiSelect
    id="scheduledDays"
    [options]="availableDaysOptions"
    display="chip"
    formControlName="scheduledDays"
    optionLabel="label"
    optionValue="value"
    placeholder="{{ 'scheduledDaysSelector.placeholder' | transloco }}"
    appendTo="body"
  />
</div>
